import { StaggerItem } from "@/components/Reveal";

export default function WorkCard({ work }) {
  const slug = work.src.split("/").pop().replace(".jpg", "");
  return (
    <StaggerItem className={work.wide ? "sm:col-span-2" : ""}>
      <figure
        data-testid={`work-card-${slug}`}
        className="group h-full overflow-hidden rounded-2xl border border-sky-200/70 bg-white shadow-sm shadow-sky-900/5 transition-all duration-300 hover:-translate-y-1 hover:border-sky-400 hover:shadow-xl hover:shadow-sky-600/10"
      >
        <div className="relative overflow-hidden">
          <img
            src={work.src}
            alt={work.alt}
            loading="lazy"
            width="1400"
            height="1400"
            className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${work.wide ? "aspect-[3/2] sm:aspect-[2/1]" : work.tall ? "aspect-[2/3]" : "aspect-square"}`}
          />
          <span className="absolute left-4 top-4 rounded-full bg-sky-600/95 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.15em] text-white shadow-lg backdrop-blur">
            {work.badge || "Before & After"}
          </span>
        </div>
        <figcaption className="p-6">
          <h3 className="text-lg font-bold text-slate-900">{work.title}</h3>
          <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{work.text}</p>
        </figcaption>
      </figure>
    </StaggerItem>
  );
}
